/* eslint-disable no-undef */
import React from 'react';
import {Route} from '@redlink/routes';
import {ApolloProvider} from '@apollo/react-hooks';
import {useApolloClient} from '@redlink/services';
import {LocaleProvider} from '@redlink/assets/locale';
import {MessageProvider} from "./components/molecules";

export default () => {
    const {client} = useApolloClient();

    return (
        <ApolloProvider client={client}>
            <LocaleProvider>
                <MessageProvider>
                    <Route/>
                </MessageProvider>
            </LocaleProvider>
        </ApolloProvider>

    );
};
